import api from "../../../../store/AuthHeader";

const getAll = (queryStr: any) => {
    return api
        .get("/country/getallcountries?"+queryStr);
};

const getById = (id: any) => {
    return api
        .get('/country/getcountrybyid?id='+id);
};

const add = (payload: any) => {
    return api
        .post("/country", payload);
};


const update = (id: any, payload: any) => {
    return api
        .put(`/country/${id}`, payload);
};

const deleteById = (itemToDeleteId: number) => {
    return api
        .delete(`/country/${itemToDeleteId}`);
};


export default {
    getAll,
    getById,
    add,
    update,
    deleteById
};